import { getDocuemtVoucherDowload } from "../services/documentosService";
import { getReservasAutorizadas } from "../services/serviceViaje";
import { FormatoFecha } from "./../utils/FormatFecha"
const dataInicial = {
    reservas: [],
    total: 0,
    fechaInicio: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    fechaFinal: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    pagina: 0,
    registroPagina: 10,
    exito: 0,
}
const GET_RESERVAS_AUTH_ALL = "GET_RESERVAS_AUTH_ALL"
const GET_RESERVAS_AUTH_BUSQUEDA_ALL = "GET_RESERVAS_AUTH_BUSQUEDA_ALL"
const GET_RESERVAS_AUTH_REGISTROS_PAGINA = "GET_RESERVAS_AUTH_REGISTROS_PAGINA"
const GET_RESERVAS_AUTH_PAGINA = "GET_RESERVAS_AUTH_PAGINA"
const GET_RESERVAS_AUTH_DOWLOAD = "GET_RESERVAS_AUTH_DOWLOAD"
const CLEAR_RESERVAS_AUTH_STATE = "CLEAR_RESERVAS_AUTH_STATE"
export default function reservasAutorizadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_RESERVAS_AUTH_DOWLOAD:
            return {
                ...state,
                exito: action.exito
            }
        case GET_RESERVAS_AUTH_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_RESERVAS_AUTH_REGISTROS_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_RESERVAS_AUTH_BUSQUEDA_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                fechaInicio: action.payload.fechaInicio,
                fechaFinal: action.payload.fechaFinal,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case GET_RESERVAS_AUTH_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total
            };
        case CLEAR_RESERVAS_AUTH_STATE:
            return {
                ...state,
                reservas: action.payload.reservas
            }
        default:
            return state;
    }
}


export const obtenerVoucherDowloadAuthAction = ({idCompra}) => async (dispatch, getSate) => {
    return await getDocuemtVoucherDowload({idCompra}).then(Response => {
        dispatch({
            type: GET_RESERVAS_AUTH_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerReservasAuthAction = () => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina, registroPagina } = getSate().reservasAuth
    return await getReservasAutorizadas({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_AUTH_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasAuthBusquedaAction = ({ FechaInicio, FechaFin }) => async (dispatch, getSate) => {
    return await getReservasAutorizadas({ FechaInicio, FechaFin ,Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_AUTH_BUSQUEDA_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                fechaInicio: FechaInicio,
                fechaFinal: FechaFin,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasAuthRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina } = getSate().reservasAuth
    return await getReservasAutorizadas({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_RESERVAS_AUTH_REGISTROS_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasAuthPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, registroPagina } = getSate().reservasAuth
    return await getReservasAutorizadas({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_AUTH_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_RESERVAS_AUTH_STATE,
        payload: {
            dataInicial,
        },
    });
}